import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'container',
    (_, [isDesktop]) => [
      `
			position: relative;
			font-size: 1rem;
			width: 100%;
		`,
      isDesktop &&
        `
			overflow-x: auto;
		`
    ]
  ]
]);
